import { Howl } from 'howler'

const state = {
  loadedPages: [],
  assets: []
}

const mutations = {
  INIT_LOADED_ASSET(state) {
    state.assets = []
  },
  ADD_LOADED_ASSET(state, payload) {
    state.assets.push(payload)
  },
  ADD_LOADED_PAGE(state, payload) {
    state.loadedPages.push(payload)
  }
}

const actions = {
  async fetchAssets({ state, commit }, { currentPage, assets }) {
    const isLoaded =
      state.loadedPages.findIndex(page => page === currentPage) >= 0
    if (isLoaded) return true
    commit('INIT_LOADED_ASSET')
    // image or sound
    const elements = []

    const promises = assets.map((asset, i) => {
      return new Promise(async resolve => {
        elements[i] =
          asset.type === 'image'
            ? new Image()
            : new Howl({
                src: asset.path
              })
        if (asset.type === 'image') elements[i].src = asset.path
        const loadAsset = () => {
          return new Promise((resolve, reject) => {
            elements[i].onload = () => {
              elements[i] = null
              resolve(asset.path)
            }
            elements[i].onerror = () => {
              console.log('onerror', elements[i])
              elements[i] = null
              reject(asset.path)
            }

            if (asset.type === 'sound') {
              if (elements[i].state() === 'loaded') {
                elements[i].unload()
                elements[i] = null
                resolve(asset.path)
                return
              }
              elements[i].on('load', () => {
                elements[i].unload()
                elements[i] = null
                resolve(asset.path)
              })
              elements[i].on('loaderror', () => {
                console.log('onerror', elements[i])
                elements[i].unload()
                elements[i] = null
                reject(asset.path)
              })
            }
          })
        }
        await loadAsset().catch(() => {
          console.error('asset loading error', asset.path)
          return
        })
        commit('ADD_LOADED_ASSET', asset)
        resolve()
      })
    })
    await Promise.all(promises)
    commit('ADD_LOADED_PAGE', currentPage)
  },
  isAssetLoaded({ state }, currentPage) {
    const isLoaded =
      state.loadedPages.findIndex(page => {
        return page === currentPage
      }) >= 0
    return isLoaded
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
